<script setup lang="ts">
const props = defineProps({
  min: {
    type: Number,
    default: 0,
  },
  max: {
    type: Number,
    default: 100,
  },
  modelValue: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['update:modelValue']);

const value = ref(props.modelValue);

const increment = () => {
  if (value.value < props.max) {
    value.value++;
  }
};

const decrement = () => {
  if (value.value > props.min) {
    value.value--;
  }
};

watch(value, (newValue) => {
  emit('update:modelValue', newValue);
});

watch(() => props.modelValue, (newValue) => {
  value.value = newValue;
});
</script>

<template>
  <div class="d-flex align-items-center">
    <div class="col">
      <button class="btn btn-primary rounded-circle btn-sm" @click="decrement" :disabled="value <= min">-</button>
    </div>
    <div>
      <label class="px-3">{{ value }}</label>
    </div>
    <div class="col">
      <button class="btn btn-primary rounded-circle btn-sm" @click="increment" :disabled="value >= max">+</button>
    </div>
  </div>
</template>

<style scoped>
button {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
}

label {
  min-width: 40px;
  text-align: center;
}
</style>
